import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTrash, FaPlus, FaTimes } from 'react-icons/fa';
import CustomButton9, { CustomButton2, CustomButton10Ca, CustomInputBox1, CustomButton3, CustomButton1, CustomButton4, CustomButton5, CustomButton6, CustomButton7, CustomButton8, CustomButton10 } from '../Templates.js';
import Spinner from '../common/Spinner';
import './MyProfile.css';

const CarManager = ({ cars, onAddCar, onDeleteCar, isLoading }) => {
  const { t } = useTranslation('common');
  const [showAddCar, setShowAddCar] = useState(false);
  const [carFormData, setCarFormData] = useState({
    brand: '',
    model: '',
    year: '',
    number: ''
  });
  const [validationErrors, setValidationErrors] = useState({});

  const handleCarInputChange = (field, value) => {
    setCarFormData(prev => ({
      ...prev,
      [field]: field === 'number' ? value.toUpperCase() : value
    }));
    
    // Clear validation errors when typing
    if (validationErrors[field]) {
      setValidationErrors(prev => ({
        ...prev,
        [field]: null
      }));
    }
  };

  const validateCarForm = () => {
    const errors = {};
    
    if (carFormData.brand && !carFormData.number) {
      errors.number = t('profile.number_required');
    }
    
    if (!carFormData.brand && carFormData.number) {
      errors.brand = t('profile.brand_required');
    }
    
    if (!carFormData.brand && !carFormData.number) {
      errors.brand = t('profile.brand_and_number_required');
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddCar = async () => {
    if (!validateCarForm()) {
      return;
    }
    
    try {
      await onAddCar(carFormData);
      
      // Reset form
      setCarFormData({
        brand: '',
        model: '',
        year: '',
        number: ''
      });
      
      setShowAddCar(false);
    } catch (error) {
      console.error('Error adding car:', error);
    }
  };

  return (
    <div className="cars-section">
      <h4>{t('profile.your_cars')}:</h4>
      <div className="cars-list">
        {cars.length > 0 ? (
          cars.map((car) => (
            <div key={car.id} className="car-item">
              <span>{car.brand} {car.model} {car.year && `(${car.year})`} - {car.number}</span>
              <CustomButton10Ca
                onClick={() => onDeleteCar(car.id)}
                disabled={isLoading}
              >
                <FaTrash size={14} />
              </CustomButton10Ca>
            </div>
          ))
        ) : (
          <p>{t('profile.no_cars')}</p>
        )}
      </div>

      <div className="Car-box">
        <CustomButton10
          label={showAddCar ? t('buttons.cancel') : t('profile.add_car')}
          onClick={() => setShowAddCar((prev) => !prev)}
        >
          {showAddCar }
        </CustomButton10>
      </div>
      
      {showAddCar && (
        <div className="addcar-box">
          <div className="car-form-field">
            <CustomInputBox1
              placeholder={t('profile.car_brand')}
              value={carFormData.brand}
              onChange={(e) => handleCarInputChange('brand', e.target.value)}
            />
            {validationErrors.brand && (
              <div className="validation-error">{validationErrors.brand}</div>
            )}
          </div>

          <div className="car-form-field">
            <CustomInputBox1
              placeholder={t('profile.car_model')}
              value={carFormData.model}
              onChange={(e) => handleCarInputChange('model', e.target.value)}
            />
          </div>

          <div className="car-form-field">
            <CustomInputBox1
              placeholder={t('profile.year')}
              value={carFormData.year}
              onChange={(e) => handleCarInputChange('year', e.target.value)}
            />
          </div>

          <div className="car-form-field">
            <CustomInputBox1
              placeholder={t('profile.plate_number')}
              value={carFormData.number}
              onChange={(e) => handleCarInputChange('number', e.target.value)}
            />
            {validationErrors.number && (
              <div className="validation-error">{validationErrors.number}</div>
            )}
          </div>

          <CustomButton2
            label={t('buttons.add')}
            onClick={handleAddCar}
            disabled={isLoading}
          >
            {isLoading && <Spinner size="small" showText={false} thickness={2} />}
          </CustomButton2>
        </div>
      )}
    </div>
  );
};

export default CarManager;